import { render, staticRenderFns } from "./CategoriaTramitesView.vue?vue&type=template&id=1ffc81b8"
import script from "./CategoriaTramitesView.vue?vue&type=script&lang=ts"
export * from "./CategoriaTramitesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports